/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import { dasherize } from "@ember/string";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type { ForcBaseArgs } from "parog-web/components/forc/abstract/base-component";
import type Patient from "parog-web/models/patient";
import { toLeft, toRight } from "ember-animated/transitions/move-over";
import type { EmberChangeset } from "ember-changeset";
import type { IntlService } from "ember-intl";
import { sleep } from "parog-web/utils/time";

interface Signature {
  Args: {
    patient: Patient;
    currentSections: Array<string>;
    save: () => void;
    changeset: EmberChangeset;
    questions: Record<string, Component>;
    translationPrefix: string;
  } & ForcBaseArgs;
}

export default class MultiStepsEditionForm extends Component<Signature> {
  @service declare intl: IntlService;

  duration = 300;

  @tracked currentIndex = 0;

  rules({ oldItems, newItems }) {
    if (oldItems[0] < newItems[0]) {
      return toLeft;
    }
    return toRight;
  }

  @action
  async previousQuestion() {
    await sleep(this.duration / 2);
    this.currentIndex--;
  }

  get currentQuestionKey(): string {
    return this.args.currentSections[this.currentIndex];
  }

  @action
  async nextQuestion() {
    await sleep(this.duration / 2);
    this.currentIndex++;
  }

  get isOnSummary(): boolean {
    return this.currentIndex == this.args.currentSections.length;
  }

  get editionFormComponent() {
    return this.args.questions[dasherize(this.currentQuestionKey)];
  }
}
